import React from "react";
import Header from "../../components/Header/Header";
import NavBar from "../../components/NavBar/NavBar";
import { Box, Typography } from "@mui/material";
import AddIcCallIcon from '@mui/icons-material/AddIcCall';

function HomeService() {
  return (
    <div className="CommingSoon">
      <Header />
      <NavBar />
      <Box
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",

          marginTop: "5%",
        }}
      >
        <img
          src="https://ayushya.in/wp-content/uploads/2022/03/medical-healthcare-service-vector-17715715-1-p15dymhq1nciotkx1uimx11dbpcztxzl84zxowt24g.png"
          alt=""
        />
        <Typography sx={{marginTop:'2%', fontWeight:'600', color:'#0D972AFA'}}>Medical Home Care</Typography>
        <Typography sx={{width:'60%',marginTop:'1%', fontWeight:'500'}}>
          Medical Home Care BD is one of the best Nursing Home Care. We also provide oxygen cylinder rent and sell,Oxygen
          Concentrator rent and sell, Nurse service, Elderly care service, New
          Born Baby Care service and medical equipments.We are 24/7 hours active
          to protect your health life.
        </Typography>
        <Box sx={{marginTop:'4%',marginBottom:'5%'}}>
            <Typography sx={{fontWeight:'600',color:'red'}}>Contact Us Now &nbsp;&nbsp;&nbsp;<span>+923058588585</span> </Typography>
        </Box>
				
      </Box>
    </div>
  );
}

export default HomeService;
